import React from 'react'
import bars from '../../assets/svg/bars.svg'
import './Loader.scss'

const LoaderSvg = () => {
    return (
        <img alt="loader" className="loader-svg" src={bars} />
    )
}

export default LoaderSvg